import { Spinner } from "react-bootstrap";
import { Feature } from "src/states/ApplicationState";
import "../css/PersonInfoStyle.css"
import { Cookies, Localization } from "@viamap/viamap2-common";
import { ProtectedFeature } from "./ProtectedFeature";
import { PersonInfoView } from "./PersonInformationView";
import { ViewButtonCheck, ViewButtonIcon } from "src/propertyInfoTemplates/PropertyComponents";
import { AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useState, useEffect } from "react";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { ManagedWindow, openWindow, WindowId } from "src/WindowManager/WindowState";
import { MIBIcon } from "src/componentsUtils/MIBIcon";

type props = {
  managedWindow: ManagedWindow;
  callBackOnClose: () => void;
  personInfo: any
}

export function PersonInformationDialog(props: props) {
  const [personDefaultCollapsed, setPersonDefaultCollapsed] =
    useState(Cookies.getCookieBoolean("PersonAutoColapsed"));
  const { dispatch: windowDispatch } = useWindowContext();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
  }, [props.personInfo]);

  function RemberCollapseSettings(val) {
    Cookies.setCookieBoolean("PersonAutoColapsed", !val);
  }

  let fold = (
    <ViewButtonCheck
      className={"no-print"}
      checked={!personDefaultCollapsed}
      onCheck={(e, val) => { RemberCollapseSettings(val); setPersonDefaultCollapsed(!val) }}
    >
      {Localization.getText("Expanded")}
    </ViewButtonCheck>
  );

  return (
    <AdvancedDragModal
      window={props.managedWindow}
      PosDefault={{ width: "800px", height: "calc(100% - 50px)", top: "50px", left: "50%", transform: "translateX(-50%)" }}
      PosDefaultNS={{ width: "calc( 100% - 30px )", height: "calc(100% - 50px)", top: "50px", left: "15px" }}
      saveKey="PersonInfo"
      onClose={() => props.callBackOnClose()}
      title={"Person"}
      subHeaderContent={
        <>
          <ProtectedFeature
            feature={Feature.OpenPersonInfoDocument}
            contentsIfNoAccess={<></>}
          >
            <ViewButtonIcon
              className="no-print"
              onClick={() => {
                // ToDo:
              }
                //   window.open(
                //     `/Personinfo/?name=${props.props.name},dateOfBirth=${props.props.dateOfBirth}`,
                //     "_blank"
                //   )
              }
              title={Localization.getText("Popout")}
            >
              <MIBIcon icon="popout" />
            </ViewButtonIcon>
          </ProtectedFeature>
          <ProtectedFeature
            feature={Feature.PrintPersonInfo}
            contentsIfNoAccess={<></>}
          >
            <>
              {!isLoading ? (
                <ViewButtonIcon
                  className="no-print"
                  onClick={() => {
                    print();
                  }}
                  title={Localization.getText("Print")}
                >
                  <MIBIcon icon="print" />
                  {/* {Localization.getText("Print")} */}
                </ViewButtonIcon>
              ) : (
                <Spinner size="sm" />
              )}
            </>
          </ProtectedFeature>
          <ProtectedFeature feature={Feature.ExplorerOwnership} contentsIfNoAccess={<></>}>
            <ViewButtonIcon
              title={Localization.getText("Show ownership graph")}
              className="no-print"
              onClick={() => {
                windowDispatch(openWindow(WindowId.OwnerShipDiagram, { personInfo: props.personInfo }))
              }}
            >
              <MIBIcon icon="ownership" />
            </ViewButtonIcon>
          </ProtectedFeature>
          {fold}

        </>
      }
    >
      {/* <div className="mit-printable-modal" > */}
      {/* <PrintHeader/> */}

      {(props.personInfo && (
        <PersonInfoView
          key={"peView"}
          foldetUd={!personDefaultCollapsed}
          cols={1}
          personInfo={props.personInfo}
          callBackOnLoaded={() => {
            setIsLoading(false);
          }}
        />
      )) ||
        "Missing Info"}
    </AdvancedDragModal>
  );
}
